// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__P1WJV","errorIcon":"ErrorPage_errorIcon__-LKdz","errorTitle":"ErrorPage_errorTitle__0qPTj","errorSubtitle":"ErrorPage_errorSubtitle__3cEj7"};